<template>
  <div>
    <div class="pa-0 ma-0" style="background-color: transparent;">       
      <div v-if="isHiddenLgAndUp" class="body-overall fonts pa-0 ma-0">
        <v-row class="pa-0 ma-0" style="height:100dvh;">
            <v-col cols="7" style="height:100dvh; background-color: white; position: relative;" class="pl-0 pr-0">
       
              <Transition name="fade" mode="out-in">
              <div v-show="isVideoLoading" class="loading-spinner2" style="position: fixed; top: 0; left: 0; width: 58vw; height: 100dvh; display: flex; justify-content: center; align-items: center; background-color: white; z-index: 1;">
              <v-progress-circular indeterminate color="black"></v-progress-circular>
              </div>
            </Transition>
            <Transition name="fade" mode="out-in">
                <video v-show="!isVideoLoading" playsinline autoplay muted loop style="position: fixed; top: 0; left: 0; width: 58vw; height:100dvh!important; object-fit: cover; z-index: 0;" @canplay="handleVideoCanPlay">
                <source src="/1920.mp4" type="video/mp4" >
                </video>
              </Transition>
              <Transition name="fade" mode="out-in">
            <div v-show="!isVideoLoading" id="bkgrdVideoFunc" :style="{ height: '100dvh!important' }">
              <v-row justify="center" class="pt-12 ma-0">
                  <LogoWhite @click="handleClickMenu('MUZ')"></LogoWhite>
              </v-row>
              <div class="typing-container pa-0 ma-0">
                <div class="fonts-desc2" id="feature-text">{{dynamicText}}
                  <span v-if="texting" class="cursor"></span><br/><br>
                  {{dynamicText2}}
                  <span v-if="texting2" class="cursor"></span>          
                </div> 
              </div>
            </div>
          </Transition>
          </v-col>
          <v-col cols="5">
            <div class="typing-container2">
              <div class="fonts-desc2" style="width: 100%;">
                <v-row>
                  <v-col cols="6" class="pa-0 ma-0 pr-1" align="end">
                    <v-btn text plain :ripple="false" class="text-none menu-btn-icon-border" style="width: 200px; height: 50px;" @click="handleClickMenu('login')">
                      Log in                 
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="pa-0 ma-0 pl-1">
                    <v-btn text plain :ripple="false" class="text-none menu-btn-icon-border" style="width: 200px; height: 50px;" @click="handleClickMenu('signup')">
                      Sign up                 
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
            <div class="fonts-desc"  style="width: 100%;">
              <v-row justify="center" class="pa-0 ma-0">
                <LogoBlack style="cursor:default;"></LogoBlack>
              </v-row>
              <v-row class="pa-0 ma-0 pb-12">
                <v-col cols="6" class="pa-0 ma-0" align="end">
                      <v-btn text plain :ripple="false" elevation="0" style="color:black!important;" class="text-none nomenu-btn-page"  @click="handleClickMenu('Terms')">
                        Terms of use
                      </v-btn>
                </v-col>
                <v-col cols="6" class="pa-0 ma-0"><span class="separator" style="color:black!important">|</span>
                      <v-btn text plain :ripple="false" elevation="0" style="color:black!important;" class="text-none nomenu-btn-page"  @click="handleClickMenu('Privacy')">
                        Privacy policy
                      </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-if="!isHiddenXs && !isHiddenSm && !isHiddenLgAndUp" class="body-overall fonts pa-0 ma-0">
        <v-row class="pa-0 ma-0" style="height:100dvh;">
          <v-col cols="6" style="height:100dvh; background-color: white; position: relative;" class="pl-0 pr-0">
            <Transition name="fade" mode="out-in">
            <div v-show="isVideoLoading2" class="loading-spinner2" style="position: fixed; top: 0; left: 0; width: 50vw; height: 100dvh; display: flex; justify-content: center; align-items: center; background-color: white; z-index: 1;">
              <v-progress-circular indeterminate color="black"></v-progress-circular>
              </div>
            </Transition>
              <Transition name="fade" mode="out-in">
            <video v-show="!isVideoLoading2" playsinline autoplay muted loop  style="position: fixed; top: 0; left: 0; width: 50vw; height:100dvh!important; object-fit: cover; z-index: 0;" @canplay="handleVideoCanPlay2">
              <source src="/1920.mp4" type="video/mp4" >
            </video>
          </Transition>
            <Transition name="fade" mode="out-in">
            <div v-show="!isVideoLoading2" id="bkgrdVideoFunc" :style="{ height: '100dvh!important' }"> 
              <v-row justify="center" class="pt-12 ma-0">
                <LogoWhite @click="handleClickMenu('MUZ')"></LogoWhite>
              </v-row>
              <div class="typing-container">
                <div class="fonts-desc3" id="feature-text">{{dynamicText}}
                  <span v-if="texting" class="cursor"></span><br/><br>
                  {{dynamicText2}}
                  <span v-if="texting2" class="cursor"></span>          
                </div> 
              </div>
            </div>
          </Transition>
          </v-col>
          <v-col cols="6">
            <div class="typing-container">
              <div class="fonts-desc2" style="width: 100%;">
                <v-row>
                  <v-col cols="6" class="pa-0 ma-0 pr-1" align="end">
                    <v-btn text plain :ripple="false" class="text-none menu-btn-icon-border" style="width: 200px; height: 50px;" @click="handleClickMenu('login')">
                      Log in                 
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="pa-0 ma-0 pl-1">
                    <v-btn text plain :ripple="false" class="text-none menu-btn-icon-border" style="width: 200px; height: 50px;" @click="handleClickMenu('signup')">
                      Sign up                 
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
            <div class="fonts-desc"  style="width: 100%;">
              <v-row justify="center" class="pa-0 ma-0">
                <LogoBlack style="cursor:default;"></LogoBlack>
              </v-row>
              <v-row class="pa-0 ma-0 pb-12">
                <v-col cols="6" class="pa-0 ma-0" align="end">
                      <v-btn text plain :ripple="false" elevation="0" style="color:black!important;" class="text-none nomenu-btn-page"  @click="handleClickMenu('Terms')">
                        Terms of use
                      </v-btn>
                </v-col>
                <v-col cols="6" class="pa-0 ma-0"><span class="separator" style="color:black!important">|</span>
                      <v-btn text plain :ripple="false" elevation="0" style="color:black!important;" class="text-none nomenu-btn-page"  @click="handleClickMenu('Privacy')">
                        Privacy policy
                      </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-if="!isHiddenLgAndUp && !isHiddenXs && !isHiddenMd" class="body-overall fonts pa-0 ma-0">
        <v-row class="pa-0 ma-0" style="height:100dvh;">
          <v-col cols="6" style="height:100dvh; background-color: white; position: relative;" class="pl-0 pr-0">
            <Transition name="fade" mode="out-in">
            <div v-show="isVideoLoading3" class="loading-spinner2" style="position: fixed; top: 0; left: 0; width: 50vw; height: 100dvh; display: flex; justify-content: center; align-items: center; background-color: white; z-index: 1;">
              <v-progress-circular indeterminate color="black"></v-progress-circular>
              </div>
            </Transition>
              <Transition name="fade" mode="out-in">
            <video v-show="!isVideoLoading3" playsinline autoplay muted loop  style="position: fixed; top: 0; left: 0; width: 50vw; height:100dvh!important; object-fit: cover; z-index: 0;" @canplay="handleVideoCanPlay3">
              <source src="/1920.mp4" type="video/mp4" >
            </video>
          </Transition>
            <Transition name="fade" mode="out-in">
            <div v-show="!isVideoLoading3" id="bkgrdVideoFunc" :style="{ height: '100dvh!important' }"> 
              <v-row justify="center" class="pt-12 ma-0">
                <LogoWhite @click="handleClickMenu('MUZ')"></LogoWhite>
              </v-row>
            <div class="typing-container">
                <div class="fonts-desc4" id="feature-text">{{dynamicText}}
                  <span v-if="texting" class="cursor2"></span><br/><br>
                  {{dynamicText2}}
                  <span v-if="texting2" class="cursor2"></span>          
                </div> 
            </div>
            </div>
          </Transition>
          </v-col>
          <v-col cols="6">
            <div class="typing-container">
              <div class="fonts-desc2" style="width: 100%;">
                  <v-row justify="center" class="pa-0 ma-0 pb-4">
                    <v-btn text plain :ripple="false" class="text-none menu-btn-icon-border" style="width: 200px; height: 50px;" @click="handleClickMenu('login')">
                      Log in                 
                    </v-btn>
                  </v-row>
                  <v-row justify="center" class="pa-0 ma-0">
                    <v-btn text plain :ripple="false" class="text-none menu-btn-icon-border" style="width: 200px; height: 50px;" @click="handleClickMenu('signup')">
                      Sign up                 
                    </v-btn>
                  </v-row>
              </div>
            </div>
            <div class="fonts-desc"  style="width: 100%;">
              <v-row justify="center" class="pa-0 ma-0">
                <LogoBlack style="cursor:default;"></LogoBlack>
              </v-row>
              <v-row class="pa-0 ma-0 pb-12">
                <v-col cols="6" class="pa-0 ma-0" align="end">
                      <v-btn text plain :ripple="false" elevation="0" style="color:black!important;" class="text-none nomenu-btn-page"  @click="handleClickMenu('Terms')">
                        Terms of use
                      </v-btn>
                </v-col>
                <v-col cols="6" class="pa-0 ma-0"><span class="separator" style="color:black!important">|</span>
                      <v-btn text plain :ripple="false" elevation="0" style="color:black!important;" class="text-none nomenu-btn-page"  @click="handleClickMenu('Privacy')">
                        Privacy policy
                      </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-if="!isHiddenLgAndUp && !isHiddenSm && !isHiddenMd" class="body-overall fonts pa-0 ma-0"  >
        <v-row class="pa-0 ma-0" style="height:100dvh;">
          <v-col cols="12" style="height:100dvh; background-color: white; position: relative;" class="pl-0 pr-0">
            <Transition name="fade" mode="out-in">
            <div v-show="isVideoLoading4" class="loading-spinner2" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100dvh; display: flex; justify-content: center; align-items: center; background-color: white; z-index: 1;">
              <v-progress-circular indeterminate color="black"></v-progress-circular>
              </div>
            </Transition>
            <Transition name="fade" mode="out-in">
            <v-img v-show="!isVideoLoading4" :src="require('@/assets/images/1920.png')" cover height="100dvh" style="position: fixed; top: 0; left: 0; width: 100vw; height:100dvh!important; object-fit: cover; z-index: 0;">
              <img @load="handleVideoCanPlay4" :src="require('@/assets/images/1920.png')" style="display: none;" />
            </v-img>
          </Transition>
          <Transition name="fade" mode="out-in">
            <div v-show="!isVideoLoading4" id="bkgrdVideoFunc2" :style="{ height: '100dvh!important' }"> 
              <v-row justify="center" class="pt-12 ma-0">
                <LogoWhite @click="handleClickMenu('MUZ')"></LogoWhite>
            </v-row>
            <div class="typing-container-mobile2 pa-0 ma-0">
                <div class="fonts-desc5" id="feature-text">{{dynamicText}}
                  <span v-if="texting" class="cursor2"></span><br/><br>
                  {{dynamicText2}}
                  <span v-if="texting2" class="cursor2"></span>          
                </div> 
            </div>

            <div class="typing-container-mobile pa-0 ma-0">
              <div class="fonts-desc2" style="width: 100%;">
                  <v-row justify="center" class="pa-0 ma-0 pb-4">
                    <v-btn text plain :ripple="false" class="text-none menu-btn-icon-border2" style="width: 200px; height: 50px;" @click="handleClickMenu('login')">
                      Log in                 
                    </v-btn>
                  </v-row>
                  <v-row justify="center" class="pa-0 ma-0">
                    <v-btn text plain :ripple="false" class="text-none menu-btn-icon-border2" style="width: 200px; height: 50px;" @click="handleClickMenu('signup')">
                      Sign up                 
                    </v-btn>
                  </v-row>
              </div>
            </div>
            <div class="fonts-desc pa-0 ma-0"  style="width: 100%; " >
              <v-row justify="center" class="pa-0 ma-0 pt-4">
              </v-row>
              <v-row justify="center" class="pa-0 ma-0 pb-12">
                <v-col cols="6" class="pa-0 ma-0" align="end">
                      <v-btn text plain :ripple="false" elevation="0" class="text-none nomenu-btn-page2"  @click="handleClickMenu('Terms')">
                        Terms of use
                      </v-btn>
                </v-col>
                <v-col cols="6" class="pa-0 ma-0"><span class="separator" style="color:white!important">|</span>
                      <v-btn text plain :ripple="false" elevation="0" class="text-none nomenu-btn-page2"  @click="handleClickMenu('Privacy')">
                        Privacy policy
                      </v-btn>
                </v-col>
              </v-row>
            </div>
            </div>
          </Transition>


          </v-col>



        </v-row>
      </div>
    </div>
  </div>
</template>

<script>

import LogoWhite from '../components/logo_white.vue';
import LogoBlack from '../components/logo_black.vue';

import { useRoute, useRouter } from 'vue-router'

export default {
  name: 'HomePage',

  components: {
    LogoWhite,
    LogoBlack
  },
  data: () => ({
        isHiddenMdAndDown: false,
        isHiddenLgAndUp: false,
        isHiddenXs: false,
        isHiddenSm: false,
        isHiddenMd: false,
        dynamicText: '',
        dynamicText2: '',
        text: "Welcome to the new world of digital music.",
        text1: " Socialize, collect and grow with us.",
        text2: " Geo Music, Tickets and more!",
        text3: " Let's define the future of digital music together!",
        delay: 20,
        texting: true,
        texting2: false,
        videoError: false,
        isVideoLoading: true,
        isVideoLoading2: true,
        isVideoLoading3: true,
        isVideoLoading4: true,
  }),
  mounted() {  
    this.typeText();
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  destroyed() {
  },
  computed: {

  },  
  created() {
    if (this.$route.query.muze != null) {
        this.$store.dispatch('setMuze', true);
    } else if (this.$route.query.nft != null) {
        this.$store.dispatch('setNFT', true);
    } else if (this.$route.query.tickets != null) {
        this.$store.dispatch('setTickets', true);
    } else if (this.$route.query.shop != null) {
        this.$store.dispatch('setShop', true);
    } else {
      this.$store.dispatch('setMuze', false);
      this.$store.dispatch('setNFT', false);
      this.$store.dispatch('setShop', false);
      this.$store.dispatch('setTickets', false);
    }

    if (this.$route.query.utm_source != null){
      this.$store.dispatch('setReferalSource', this.$route.query.utm_source);
    }
    if (this.$route.query.utm_medium != null){
      this.$store.dispatch('setReferalMedium', this.$route.query.utm_medium);
    }
    if (this.$route.query.utm_campaign != null){
      this.$store.dispatch('setReferalCampaign', this.$route.query.utm_campaign);
    }

    if (this.$route.matched.some(({ name }) => name === 'Unsubscribe')) {
      var uid2 = this.$route.params.uid;
      this.$store.dispatch('unsubscribe', { uid: uid2}).then( response => {
          console.log('Unsubscribe success');
        }).catch( error => {
          if (!error.response) {
           console.log('Unsubscribe failed');
          }
        })
    }

    if (this.$route.query.logoff != null){
      const router = useRouter()
      router.replace({ query: {} })
      this.$store.dispatch('logout');
    }

  }, 
  methods: {
    checkScreenSize() {
      const width = window.innerWidth;
      this.isHiddenMdAndDown = width <= 960; // Przykładowa szerokość dla md
      this.isHiddenLgAndUp = width >= 1200; // Przykładowa szerokość dla lg
      this.isHiddenXs = width < 600; // Przykładowa szerokość dla xs
      this.isHiddenSm = width >= 600 && width < 960; // Przykładowa szerokość dla sm
      this.isHiddenMd = width >= 960 && width < 1200;
    },
    async typeText() {
      this.texting = true;
      this.texting2 = false;
      let i = 0;
      while (i < this.text.length) {
        await this.waitForMs(this.delay);
        this.dynamicText += this.text[i];
        i++;
      }
      await this.waitForMs(2000);
      this.typeText1();
    },
    async typeText1() {
      let i = 0;
      while (i < this.text1.length) {
        await this.waitForMs(this.delay);
        this.dynamicText += this.text1[i];
        i++;
      }
      await this.waitForMs(2000);
      this.typeText2();
    },
    async typeText2() {
      let i = 0;
      while (i < this.text2.length) {
        await this.waitForMs(this.delay);
        this.dynamicText += this.text2[i];
        i++;
      }
      await this.waitForMs(2000);
      this.typeText3();
    },
    async typeText3() {
      let i = 0;
      this.texting = false;
      this.texting2 = true;
      while (i < this.text3.length) {
        await this.waitForMs(this.delay);
        this.dynamicText2 += this.text3[i];
        i++;
      }
      await this.waitForMs(2000);
      this.texting = true;
      this.texting2 = false;
      this.dynamicText2 = ''
      this.dynamicText = ''
      await this.waitForMs(3000);

      this.typeText();
    },
    waitForMs(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    handleClickMenu(link){
      if (link === 'Terms'){
        window.open('https://muzible.com/terms','_blank');
      } else if (link === 'Privacy'){
        window.open('https://muzible.com/privacy','_blank');
      } else if (link === 'MUZ'){
        window.location.href='https://muzible.com/';
      } else {
        if (this.$route.name !== link ) {
          this.$router.push({ name: link });
        }
      }
    },
    handleVideoCanPlay() {
      this.isVideoLoading = false;
    },
    handleVideoCanPlay2() {
      this.isVideoLoading2 = false;
    },
    handleVideoCanPlay3() {
      this.isVideoLoading3 = false;
    },
    handleVideoCanPlay4() {
      this.isVideoLoading4 = false;
    },

  },
}
</script>

<style lang="scss" scoped>

@use './css/styles.scss';

@keyframes blink {
  0% {
    opacity: 1;
  }
  40% {
    opacity: 1;
  }
  60% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease!important;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0!important;
}

.typing-container {
  display: flex;
  
  align-items: center; /* Vertically center */
  height: 65vh!important;

}

.typing-container2 {
  display: flex;
  
  align-items: center; /* Vertically center */
  height: 60vh!important;

}

.typing-container-mobile {
  display: flex;
  
  align-items: center; /* Vertically center */
  min-height: 150px!important;

}
.typing-container-mobile2 {
  display: flex;
  
  align-items: center; /* Vertically center */
  min-height:300px;
}

.cursor {
  display: inline-block;
  width: 16px;
  height: 30px;
  background-color: white;
  margin-left: 2px;
  animation: blink 0.6s linear infinite alternate;
}

.cursor2 {
  display: inline-block;
  width: 16px;
  height: 26px;
  background-color: white;
  margin-left: 2px;
  animation: blink 0.6s linear infinite alternate;
}

#feature-text {
  margin-left: 8px;
  color: white;
}

:deep(.v-btn:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true])>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item:hover)>.v-list-item__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item__append){
  display: inline-block;
}

#videoContainer {
  position: relative;
  box-sizing: border-box;
  max-height: 1000px;
  transition: height 0.10s linear;
}

#videoContent {
  position: sticky;
  top: 0;
  max-height: 100dvh;
  transition: height 0.10s linear;
}

#bkgrdVideoOverlay {
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  max-height: 100dvh!important;
  object-fit: cover; 
  background-color: #00000000; 
  z-index: 5;
  transition: height 0.10s linear;
}
#bkgrdVideoFunc {
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  max-height: 100dvh!important;
  object-fit: cover; 
  background-color: #00000000; 
  transition: height 0.10s linear;
}

#bkgrdVideoFunc2 {
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  max-height: 100dvh!important;
  object-fit: cover; 
}

#bkgrdVideo {
  width: 100%;
  max-height: 100dvh;
  object-fit: cover; 
  z-index:1;
  transition: height 0.10s linear;
}
.overall {
  background-color: white !important;
  object-fit: cover; 
  height: 100%; 
  display: block;
}
.body-overall {
  background-color: white !important;
  height: 100dvh;
  margin: 0; /* Remove default margin */
  padding: 0; /* Remove default padding */
  z-index: 3;
}
.nomenu-btn-page {
  color: black;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 16px;
  transition: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-page2 {
  color: white;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 16px;
  transition: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-page2.active,
.nomenu-btn-page2:hover {
  color: white;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-page2::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 27px;
  width: 100%; /* Spread the line over the text and icon */
  height: 1px; /* Line thickness */
  background-color: white; /* Color of the underline */
  opacity: 1; /* Initially hide the underline */
}

.nomenu-btn-page2.active::before,
.nomenu-btn-page2:hover::before {
  opacity: 0.3; /* Show the underline when hovering */
}


.separator {
  color: black;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 16px;
  transition: none !important;
  background-color: transparent !important;
}

.nomenu-btn-page.active,
.nomenu-btn-page:hover {
  color: black;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-page::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 27px;
  width: 100%; /* Spread the line over the text and icon */
  height: 1px; /* Line thickness */
  background-color: black; /* Color of the underline */
  opacity: 1; /* Initially hide the underline */
}

.nomenu-btn-page.active::before,
.nomenu-btn-page:hover::before {
  opacity: 0.3; /* Show the underline when hovering */
}

.nomenu-btn-link {
  color: white;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 20px;
  transition: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-link.active,
.nomenu-btn-link:hover {
  color: white;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-link::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 30px;
  width: 100%; /* Spread the line over the text and icon */
  height: 1px; /* Line thickness */
  background-color: white; /* Color of the underline */
  opacity: 0; /* Initially hide the underline */
}

.nomenu-btn-link.active::before,
.nomenu-btn-link:hover::before {
  opacity: 1; /* Show the underline when hovering */
}


</style>
